import { SxStyleProp } from 'theme-ui';

export const baseStyle: { [k: string]: SxStyleProp } = {
  mainBackgroundImage: {
    width: '100%',
    height: ['auto', '1112px'],
  },
  mainContainer: {
    paddingTop: ['20px', '106px'],
  },
  title: {
    marginBottom: [null, '60px'],
    color: 'white',
    textAlign: 'center',
  },
  flexContainer: {
    flexDirection: ['column', 'row'],
    alignItems: ['center', 'flex-start'],
    justifyContent: 'space-around',
    padding: ['50px 20px', '100px 0px'],
  },
  box: {
    width: '100%',
    maxWidth: '560px',
    height: ['auto', '529px'],
    marginBottom: ['20px', 'revert'],
    textAlign: 'center',
    '.card-read-more': {
      justifyContent: 'center',
    },
  },
};
